export default "__VITE_ASSET__BB1zx595__"